import ndsTokens from 'nicollet-tokens';
import { paramCase } from 'change-case';

var cssObjectToCssText = function cssObjectToCssText(obj) {
  return Object.entries(obj).map(function (pair) {
    return "".concat(paramCase(pair[0]), ": ").concat(pair[1], ";");
  }).join('\n');
};
/*
 * The CSS font reset for Nicollet components. It emits all our defensive defaults, but also accepts an optional jsStyle
 * object of CSS properties to fold into the defaults so you can get the specific styles you need.
 */


var ndsFontReset = function ndsFontReset(customCssObject) {
  var baselineCssObject = {
    fontFamily: ndsTokens.font.family.sansSerif,
    fontSize: ndsTokens.font.size.text.base,
    lineHeight: ndsTokens.font.lineHeight.text,
    fontStyle: 'normal',
    fontWeight: 'normal',
    letterSpacing: 0,
    textIndent: 0,
    textShadow: 'none',
    textTransform: 'none',
    verticalAlign: 'baseline',
    whiteSpace: 'normal'
  };
  var finalCssObject = Object.assign({}, baselineCssObject, customCssObject);
  return cssObjectToCssText(finalCssObject);
};

export { ndsFontReset };
